import { FC } from 'react';
import { I18nextProvider } from 'react-i18next';
import { RouterProvider } from 'react-router-dom';

import { CssBaseline } from '@mui/material';
import { ThemeProvider } from '@mui/system';
import { LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs';

import CartContextProvider from '@/features/Checkout/components/Cart/context/CartContext';
import i18n from '@/shared/configs/i18n';
import getRouterConfig from '@/shared/configs/router';
import theme from '@/shared/configs/theme';

import AuthProvider from './shared/contexts/auth';
import DataGridFilterProvider from './shared/contexts/dataGridFilter';
import NotificationsContextProvider from './shared/contexts/notifications';

type AppProps = {
  basename: string;
};

const App: FC<AppProps> = ({ basename }) => {
  return (
    <I18nextProvider i18n={i18n}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <AuthProvider>
          <NotificationsContextProvider>
            <DataGridFilterProvider>
              <ThemeProvider theme={theme}>
                <CartContextProvider>
                  <CssBaseline />
                  <RouterProvider router={getRouterConfig(basename)} />
                </CartContextProvider>
              </ThemeProvider>
            </DataGridFilterProvider>
          </NotificationsContextProvider>
        </AuthProvider>
      </LocalizationProvider>
    </I18nextProvider>
  );
};

export default App;
